import clsx from "clsx"
import { FC } from "react"
import { Trans, useTranslation } from "react-i18next"
import { getHowItWorksImg } from "../../helpers/getHowItWorksImg.ts"
import { HowItWorksImg } from "../HowItWorksImg"
import { HowItWorksText } from "../HowItWorksText"
import { HowItWorksTitle } from "../HowItWorksTitle"
import styles from "./HowItWorksSlide.module.scss"
import { IHowItWorksSlide } from "./types.ts"

export const HowItWorksScreenSlide: FC<IHowItWorksSlide> = ({ language }) => {
  const { t } = useTranslation("howItWorks")
  return (
    <div className={clsx(styles.HowItWorksSlide, styles.slide_screen)}>
      <HowItWorksTitle>{t("slides.screen.title")}</HowItWorksTitle>
      <HowItWorksText position="center">
        <Trans
          i18nKey="slides.screen.text"
          ns="howItWorks"
          components={{ span: <span />, br: <br /> }}
        />
      </HowItWorksText>
      <HowItWorksImg
        className={clsx(styles.HowItWorksSlide_img)}
        src={getHowItWorksImg("screen", language)}
      />
    </div>
  )
}
